export function DownIcon({ className = "" }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36517 9.36321C7.71664 9.01174 8.28649 9.01174 8.63796 9.36321L12.0016 12.7268L15.3652 9.36321C15.7166 9.01174 16.2865 9.01174 16.638 9.36321C16.9894 9.71469 16.9894 10.2845 16.638 10.636L12.638 14.636C12.4692 14.8048 12.2403 14.8996 12.0016 14.8996C11.7629 14.8996 11.5339 14.8048 11.3652 14.636L7.36517 10.636C7.01369 10.2845 7.01369 9.71469 7.36517 9.36321Z"
        fill="currentColor"
      />
    </svg>
  );
}
